import { h } from "preact";

import IconProps from "./IconProps";

function IconArrowLeft({ color, width, height }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 9 16">
            <path fill={color} d="M8.7 14.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-7-7c-.4-.4-.4-1 0-1.4l7-7c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L2.4 8l6.3 6.3z"/>
        </svg>
    );
}

IconArrowLeft.defaultProps = {
    color: "var(--teflon)",
    width: 9,
    height: 16
};

export default IconArrowLeft;
